import { render, staticRenderFns } from "./NetPrice.vue?vue&type=template&id=573c24e2&"
import script from "./NetPrice.vue?vue&type=script&lang=js&"
export * from "./NetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports